export const initial = {
  popup: {
    type: null,
    data: {},
  },
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/ui.state.js
 **/